import { Controller } from "stimulus"
import $ from "jquery"

export default class extends Controller {
  static targets = ["performerRole", "poolSelect", "poolLabel", "poolHint"]

  connect() {
    this.boundFilter = () => this.filterPool()
    if (this.hasPerformerRoleTarget) {
      this.performerRoleTarget.addEventListener("change", this.boundFilter)
    }
    // Run after Select2 init on the prescreen layout (next tick).
    setTimeout(() => this.filterPool(), 0)
  }

  disconnect() {
    if (this.hasPerformerRoleTarget) {
      this.performerRoleTarget.removeEventListener("change", this.boundFilter)
    }
  }

  filterPool() {
    if (!this.hasPerformerRoleTarget || !this.hasPoolSelectTarget) {
      return
    }

    const role = this.performerRoleTarget.value || "grader"
    const select = this.poolSelectTarget
    const dataKey = role === "adjudicator" ? "adjudicator" : "grader"

    Array.from(select.options).forEach((option) => {
      const allowed = option.dataset[dataKey] === "true"
      option.hidden = !allowed
      option.disabled = !allowed
      if (!allowed) {
        option.selected = false
      }
    })

    const label = role.charAt(0).toUpperCase() + role.slice(1)
    if (this.hasPoolLabelTarget) {
      this.poolLabelTarget.textContent = `${label} pool`
    }
    if (this.hasPoolHintTarget) {
      this.poolHintTarget.innerHTML =
        `Trial users with the <strong>${label}</strong> role who should receive cases for this stage.`
    }

    this.refreshSelect2(select)
  }

  refreshSelect2(select) {
    const $select = $(select)
    if ($select.hasClass("select2-hidden-accessible")) {
      $select.trigger("change.select2")
    }
    this.element.dispatchEvent(new CustomEvent("prescreen:refresh-selects", { bubbles: true }))
  }
}
